/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_NowInputs */

const en_workflow_time_now = /** @type {(inputs: Workflow_Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

const ja_workflow_time_now = /** @type {(inputs: Workflow_Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在時刻`)
};

const fr_workflow_time_now = /** @type {(inputs: Workflow_Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenant`)
};

const de_workflow_time_now = /** @type {(inputs: Workflow_Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt`)
};

/**
* | output |
* | --- |
* | "Now" |
*
* @param {Workflow_Time_NowInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_now = /** @type {((inputs?: Workflow_Time_NowInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_NowInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_now(inputs)
	if (locale === "ja") return ja_workflow_time_now(inputs)
	if (locale === "fr") return fr_workflow_time_now(inputs)
	return de_workflow_time_now(inputs)
});